<template>
	<div class="wsstatebg_div">
		<div v-if="iType == '0'" class="content_div">
			<img class="tip_icon" src="../../static/talks/t_tipincon.png"/>
			<div class="text_div">{{titleStr}}</div>
			<div class="confirm_btn" @click="confirmAction">确认</div>
			<!-- <el-button type="primary" size="mini" class="confirm_btn" @click="confirmAction">确认</el-button> -->
		</div>
		<div v-else-if="iType == '1'" class="content_div">
			<img class="tip_icon" src="../../static/talks/t_tipincon.png"/>
			<div class="text_div">{{titleStr}}</div>
		</div>
	</div>
</template>

<script>
	
	export default {
		name: "commonTip",
		
		props:['iType', 'titleStr'], //0-被踢跳到登录页  1-ws重连
		
		data() {
			return {
				
			}
		},
		
		methods: {
			confirmAction() {
				console.log('conmonTip confirmAction')
				this.$emit('tipConfirm')
			}
		}
	}
	
</script>

<style scoped="scoped">
	
	.wsstatebg_div {
		width: 100vw;
		height: 3.5rem;
		color: #5A9CF8;
		/* background-color: #FC427B; */
		position: absolute;
		top: 0;
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: flex-end;
		min-width: 1000px;
		z-index: 100;
	}
	
	.content_div {
		width: 400px;
		height: 40px;
		background: #F4F7FB;
		border-radius: 8px;
		border: 1px solid #5A9CF8;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	
	.text_div {
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #5A9CF8;
	}
	
	.tip_icon {
		width: 18px;
		height: 18px;
		margin-left: 15px;
		margin-right: 15px;
	}
	
	.confirm_btn {
		width: 40px;
		height: 20px;
		background: #5A9CF8;
		border-radius: 5px;
		font-size: 10px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #FFFFFF;
		margin-left: 7.5rem;
	}
	
</style>
